<template>
<nav v-if="$router.currentRoute.name!='ticket'&&$router.currentRoute.name!='ticketList'" class="navbar navbar-expand-lg navbar-light bg-light">
  <button  v-if="currentUser!=null" @click="isNavToggle=!isNavToggle" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <router-link to="/" class="navbar-brand">
    <a class="navbar-brand" href="#">
      <img src="/logo.png" width="30" height="30" class="d-inline-block align-top" alt="">
      {{header | translate}} <span class="badge badge-secondary">{{stage | translate}}</span>
    </a>
  
  </router-link>
  

  <div v-if="currentUser!=null" :class="{'show':isNavToggle}" class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <router-link to="/settings" activeClass="active" tag="li" class="nav-item "><a class="nav-link">{{'Settings' | translate}}</a></router-link>
      <router-link to="/" exactActiveClass="active" tag="li" class="nav-item "><a class="nav-link">{{'Create Plan' |translate}}</a></router-link>
      <!-- <router-link to="/plan/" activeClass="active" tag="li" class="nav-item "><a class="nav-link">Plan List</a></router-link> -->
       <li class="nav-item dropdown" @click="isDropDown=!isDropDown">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
          <!-- {{'Plan List' | translate}} -->
          {{'Launch Plan' | translate}}
        </a>
        <table :class="{'show':isDropDown}" class="dropdown-menu table-borderless" aria-labelledby="navbarDropdown">
          <tbody v-for="currentFanPageID in Array.from(new Set(Object.values(planList).map((p)=>p.status=='launch'?p.fanPageID:null).filter(a=>a!=null)))" :key="currentFanPageID">

            <tr><th colspan="2" class="">{{currentFanPageID}}:</th><th></th></tr>
            <tr v-for="(value,index) in Object.values(planList).map((p)=>p.fanPageID==currentFanPageID&&p.status=='launch'?p:null).filter((a)=>a!=null)" :key="index" class="">
              <td><a class="dropdown-item" :href="'/plan/'+value.planID">{{value.planName}}</a></td>
              <td>
                <button type="button" @click="suspendPlan(value.planID)" class="delete close text-secondary p-1" aria-label="Close">
                <i class="far fa-pause-circle"></i>
              </button>
              </td>
            </tr>
          </tbody>
          <!-- <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="#">Something else here</a> -->
        </table>
      </li>
    </ul>
    <form class="form-inline my-2 my-lg-0">
      <!-- <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search"> -->
      
      <!-- <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Launch</button> -->
      <img style="height:50px; width:50px" class="img-thumbnail" :src="currentUser.photoURL">
      <div>{{currentUser.displayName}}</div>
    </form>
  </div>
</nav>
</template>

<script>
import { mapActions } from "vuex";
import firebase from 'firebase';

export default {
  data() {
    return {
      header:process.env.VUE_APP_HEADER,
      stage:process.env.VUE_APP_STAGE,
      currentUser:null,
      planRef:null,
      planList:{},
      isDropDown:false,
      isNavToggle:false
    };
  },
  watch: {
    currentUser(){
      this.getPlanList();
    }
  },
  methods: {
    getCurrentUser(){//Warning: massive duplicate code
      var self =this;
      firebase.auth().onAuthStateChanged(function(user) {
          if (user) {
              self.currentUser = user;
          } else {
              console.log('No user has signed in.');
          }
      })
    },
    getPlanList(){
      console.log('Getting Plan List...');
            var databaseRef = firebase.database().ref('users/' + this.currentUser.uid + '/plans');
            var self = this;
            // databaseRef.once('value')
            //     .then(function(snapshot) {
            //         if(snapshot.val()){
            //             console.log('Got ' + Object.keys(snapshot.val()).length + ' Plans');
            //             self.planList = snapshot.val();
                        
            //         }else{
            //             console.log('Got no Plan');
            //         }
                    
            //     },function(error){
            //         console.log('Getting Plan List error: ' + error);

            //     });
            self.planRef = databaseRef.on('value',function(snapshot) {
                    if(snapshot.val()){
                        console.log('Got ' + Object.keys(snapshot.val()).length + ' Plans');
                        self.planList = snapshot.val();
                        
                    }else{
                        console.log('Got no Plan');
                    }
                    
                });
                
    },
    suspendPlan(id){
            console.log('Suspending Plan: '+id+' ...');
            var planRef = firebase.database().ref('users/' + this.currentUser.uid + '/plans');
            var self = this;
            var updates = {};
            updates[id+'/status'] = 'suspended';
            return planRef.update(updates)
                .then(()=>console.log('Suspending Plan success'))
                .catch(error=>{
                    console.log('Suspending Plan error:'+error);
                });

    },
  },
  mounted(){//Warning: massive duplicate code
    this.getCurrentUser();

  }
};
</script>
<style scoped>
.delete {
  opacity:0.1;
}
.delete:hover{
  opacity:1;

}
tbody{
  display: block;
}
tr{
  display:flex;
  justify-content: space-between;
}
</style>
